const SearchResultHoverBackground = () => {
  return (
    <div className="absolute top-0 bottom-0 -right-4 -left-4 rounded-2xl opacity-0 transition-opacity ease-in-out bg-bg-faint/50 group-hover:opacity-100" />
  );
};

export default SearchResultHoverBackground;
